import React from 'react';
import { toast } from 'react-toastify';
import { bookingToCalendarEvent, downloadBookingIcs, openGoogleCalendar } from '../../utils/calendar';
import { hapticSuccess } from '../../utils/haptic';
import '../../styles/AddToCalendarButton.css';

function AddToCalendarButton({ booking, salonTitle, salonAddress, durationMinutes, compact = false }) {
  if (!booking?.date || !booking?.time) return null;

  const event = bookingToCalendarEvent(booking, { salonTitle, salonAddress, durationMinutes });

  const handleGoogle = () => {
    openGoogleCalendar(event);
    hapticSuccess();
  };

  const handleIcs = () => {
    try {
      downloadBookingIcs(event);
      hapticSuccess();
      toast.success('تم تحميل ملف التقويم');
    } catch {
      toast.error('تعذّر إنشاء ملف التقويم');
    }
  };

  return (
    <div className={`add-to-calendar ${compact ? 'add-to-calendar--compact' : ''}`}>
      {!compact && <span className="add-to-calendar-label">أضف للتقويم</span>}
      <div className="add-to-calendar-actions">
        <button
          type="button"
          className="add-to-calendar-btn add-to-calendar-btn--google"
          onClick={handleGoogle}
          title="Google Calendar"
          aria-label="أضف إلى Google Calendar"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="add-to-calendar-icon">
            <path fill="currentColor" d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V10h14v10zM5 8V6h14v2H5z" />
          </svg>
          Google
        </button>
        <button
          type="button"
          className="add-to-calendar-btn add-to-calendar-btn--ics"
          onClick={handleIcs}
          title="Apple Calendar / Outlook"
          aria-label="تحميل ملف التقويم"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="add-to-calendar-icon">
            <path fill="currentColor" d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
          </svg>
          {compact ? 'تقويم' : 'تحميل (.ics)'}
        </button>
      </div>
    </div>
  );
}

export default AddToCalendarButton;
